






import Vue from 'vue'
import './QualityLabel.scss'
import { Stream } from '@/types/streams'

export default Vue.extend({
  name: 'QualityLabel',
  props: {
    quality: {
      type: [Object as () => Stream, String],
      required: false,
      default: undefined
    },
    fps: {
      type: String
    },
    rate: {
      type: Object
    }
  },
  data: () => ({
    width: 1280,
    height: 720,
    videobitrate: 6 as number|undefined,
    framerate: 30,
    interlaced: false
  }),
  mounted () {
    if (typeof this.quality === 'string' && this.quality !== undefined) {
      this.height = Math.round(parseInt(this.quality.split('p')[0]))
      this.width = this.height * 16 / 9
      this.videobitrate = Math.round(parseInt(this.quality.split('p')[1])) / 1000.0
    } else if (typeof this.quality === 'object') {
      if (this.quality.variants !== undefined) {
        if (this.quality.variants.original !== undefined && this.quality.variants.original.videoinfo !== undefined) {
          const resolution = this.quality.variants.original.videoinfo.frameSize
          if (resolution !== undefined) {
            this.width = Math.floor(parseInt(resolution.split('x')[0]))
            this.height = Math.floor(parseInt(resolution.split('x')[1]))
            this.framerate = this.quality.variants.original.videoinfo?.frameRate ?? 30
            this.videobitrate = undefined
          }
        }
      } else if (!!this.quality.rate) {
        // Social Media CustomRtmpDestination e.g. YouTube live output
        const rate = this.quality.rate
        this.width = rate.width ?? 1280
        this.height = rate.height ?? 720
        this.framerate = parseFloat(rate.fps ?? '30')
        this.videobitrate = rate.video_bitrate
        this.interlaced = rate.interlaced ?? false
      }
    }
    if (this.fps !== undefined) {
      this.framerate = parseFloat(this.fps.replace('Hz', ''))
    }
    if (this.rate !== undefined) {
      if (this.rate.width !== undefined) {
        this.width = this.rate.width
      }
      if (this.rate.height !== undefined) {
        this.height = this.rate.height
      }
      if (this.rate.fps) {
        this.framerate = this.rate.fps
      }
      if (this.rate.video_bitrate !== undefined) {
        this.videobitrate = this.rate.video_bitrate / 1000
      }
    }
  },
  computed: {
    qualitysummary (): string {
      const i_type =  (this.interlaced !== undefined && this.interlaced) ? 'i': 'p'
      if (!this.framerate || this.framerate === 0)
        return this.height + i_type
      else
        return this.height + i_type + this.framerate
    },
    qualitystring (): string {
      let q = ''
      q += this.width + 'x' + this.height + ' '
      q += '@' + this.framerate + 'Hz'
      if (this.videobitrate !== undefined) {
        q += ' ' + this.videobitrate + 'Mbps'
      }
      return q
    }
  }
})
